// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"style_checkboxContainer__2vOGp","checkbox":"style_checkbox__na2KW","checkboxIcon":"style_checkboxIcon__1EoNW"};